import { ITemplateStatus, Industry } from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { ITemplatesIndustryWithCategories } from '../../../../models/AdminModels';
import { ISelectBoxOption } from '../../../../web/components/SelectBox';
import { IndustryCategorySelector } from '../IndustryCategorySelector';
import { styleSheet } from './styles';

interface IProps {
	categoryOptions: ITemplatesIndustryWithCategories[];
	onCheckboxChanged(industry: Industry): (e: React.ChangeEvent<HTMLInputElement>) => void;
	onSelectBoxChanged(industry: Industry): (selectedOption: ISelectBoxOption<string>) => void;
	readOnly?: boolean;
	selectedOptions: ITemplateStatus[];
}

export const IndustryCategorySection = ({
	categoryOptions,
	selectedOptions,
	onCheckboxChanged,
	onSelectBoxChanged,
	readOnly,
}: IProps) => {
	return (
		<div className={`${css(styleSheet.container)} industry-category-selector `}>
			<div className={css(styleSheet.sectionLine)} />
			<div className={`industries-header ${css(styleSheet.header)}`}>Industries</div>
			<div className={css(styleSheet.selectors)}>
				{categoryOptions?.map(x => {
					// selected category
					const selectedOption = {
						title: selectedOptions.find(o => o.industry === x.industry)?.category,
						value: selectedOptions.find(o => o.industry === x.industry)?.category,
					};

					return (
						<IndustryCategorySelector
							key={x.industry}
							industryName={x.industry}
							onCheckboxChanged={onCheckboxChanged(x.industry)}
							checkboxDisabled={!selectedOptions?.some(o => o.industry === x.industry)}
							checkboxChecked={selectedOptions?.some(o => o.industry === x.industry)}
							onSelectBoxChanged={onSelectBoxChanged(x.industry)}
							options={x.categoryNames
								?.map(c => ({ title: c, value: c }))
								.filter(
									c =>
										c.title !== 'Featured' &&
										c.title !== 'HTML Newsletters' &&
										c.title !== 'Archived' &&
										c.title !== 'Uncategorized'
								)}
							readOnly={readOnly}
							selectedOption={selectedOption}
						/>
					);
				})}
			</div>
		</div>
	);
};
